import ChatBubbleClusterFileUrl from '@capturi/assets/images/ChatBubbleCluster.svg'
import ColoredBackgroundFileUrl from '@capturi/assets/images/ColoredBackground.svg'
import PuzzelFlowerFileUrl from '@capturi/assets/images/PuzzelFlower.svg'
import ChordFileUrl from '@capturi/assets/images/chord.svg'
import { Box } from '@chakra-ui/react'
import { Variants, motion } from 'framer-motion'
import React from 'react'

const backgroundAnimation: Variants = {
  hidden: { y: '100%', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.5 },
  },
}

const puzzelAnimation: Variants = {
  hidden: { y: '100%', opacity: 0, rotate: -85 },
  visible: {
    y: 0,
    opacity: 1,
    rotate: 0,
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.7 },
  },
}

const chatBubbleAnimation: Variants = {
  hidden: { y: '100%', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeOut', delay: 1.2 },
  },
}

const chordAnimation: Variants = {
  hidden: { x: '-100%', opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeOut', delay: 1.4 },
  },
}

const WavesBackground: React.FC = () => {
  return (
    <Box pos="absolute" bottom={0} top={0} left={0} right={0}>
      <Box
        as={motion.div}
        pos="absolute"
        bottom={0}
        left={0}
        right={0}
        aria-hidden
        width="100%"
        variants={backgroundAnimation}
        initial="hidden"
        animate="visible"
      >
        <ColoredBackgroundFileUrl />
      </Box>
      <Box
        as={motion.div}
        pos="absolute"
        bottom={0}
        right={0}
        aria-hidden
        width="20vw"
        maxWidth="400px"
        display={{ base: 'none', '3xl': 'block' }}
        variants={puzzelAnimation}
        initial="hidden"
        animate="visible"
      >
        <PuzzelFlowerFileUrl />
      </Box>
      <Box
        as={motion.div}
        pos="absolute"
        bottom={0}
        left={0}
        aria-hidden
        width="20vw"
        maxWidth="400px"
        display={{ base: 'none', '3xl': 'block' }}
        variants={chatBubbleAnimation}
        initial="hidden"
        animate="visible"
      >
        <ChatBubbleClusterFileUrl />
      </Box>
      <Box
        as={motion.div}
        pos="absolute"
        top={0}
        left={0}
        aria-hidden
        width="20vw"
        maxWidth="400px"
        display={{ base: 'none', '3xl': 'block' }}
        variants={chordAnimation}
        initial="hidden"
        animate="visible"
      >
        <ChordFileUrl />
      </Box>
    </Box>
  )
}

export default WavesBackground
